export default __webpack_public_path__ + "static/favicon-5ee5f0a3b9b93f52a614117da949c656.ico";